import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-shimmer-dashboard-count',
  templateUrl: './shimmer-dashboard-count.component.html',
  styleUrl: './shimmer-dashboard-count.component.css'
})
export class ShimmerDashboardCountComponent {
  @Input() count: number = 6;

}
